import { Dispatch } from 'redux'
import {
  DetailInformationDataType,
  FetchSalaryCardDetailInfoFailureAction,
  FetchSalaryCardDetailInfoRequestAction,
  FetchSalaryCardDetailInfoSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardType,
} from 'store/types/salaryCard'
export const fetchSalaryCardDetailInfoRequest =
  (): FetchSalaryCardDetailInfoRequestAction => ({
    type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_REQUEST,
  })
import { getAllDetailsInfosOrder } from '../../../services/SalaryCards/detailsInfo'
export const fetchSalaryCardDetailInfoSuccess = (
  detailInformationData: DetailInformationDataType
): FetchSalaryCardDetailInfoSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS,
  payload: detailInformationData,
})
export const fetchSalaryCardDetailInfoFailure = (
  error: any
): FetchSalaryCardDetailInfoFailureAction => ({
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_FAILURE,
  payload: error,
})
export const fetchDetailInformation = (orderNo: string) => {
  return async (dispatch: Dispatch<SalaryCardActions>) => {
    dispatch(fetchSalaryCardDetailInfoRequest())

    try {
      const data= await getAllDetailsInfosOrder(orderNo)
      
      dispatch(fetchSalaryCardDetailInfoSuccess(data))
    } catch (error) {
      dispatch(fetchSalaryCardDetailInfoFailure(error.message))
    }
  }
}
